import { Card, Modal, Typography } from "antd";
import { useState } from "react";
import { useForm } from "antd/es/form/Form";
import { RegisterForm } from "../components/RegisterForm";
import { VerifyOtpForm } from "../components/VerifyOptForm";
import { useAuth } from "../../../hooks/useAuth";
import { logo } from "../../../constants/common";
import { Navigate, useNavigate } from "react-router-dom";

export function Register() {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = useForm();
  const [verifyOtpForm] = useForm();
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const { data, loading, register, verifyOtp } = useAuth();

  const handleRegister = async (values) => {
    try {
      const result = await register.mutateAsync({ ...values, role: "user" });
      setEmail(result.email);
      form.resetFields();
      setIsModalVisible(true);
    } catch (error) {
      console.error(error);
    }
  };

  const handleVerifyOtp = async (values) => {
    try {
      await verifyOtp.mutateAsync({ ...values, email });
      setIsModalVisible(false);
      verifyOtpForm.resetFields();
      navigate("/bang-dieu-khien");
    } catch (error) {
      console.error(error);
    }
  };

  if (loading) {
    <Typography.Text>Đang tải...</Typography.Text>;
  }

  if (data) {
    return <Navigate to="/bang-dieu-khien" replace />;
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
      }}
    >
      <Card
        style={{
          width: "100%",
          maxWidth: 500,
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
          borderRadius: "12px",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <img
            src={logo}
            alt="Chùa Diệu Pháp"
            style={{
              width: 64,
              height: 64,
              marginBottom: 16,
            }}
          />
          <Typography.Title
            level={2}
            style={{ margin: 0, color: "#147265", marginBottom: 8 }}
          >
            Đăng ký
          </Typography.Title>

          <Typography.Text type="secondary" style={{ fontSize: "14px" }}>
            Chào mừng bạn đăng ký hệ thống quản lý Chùa Diệu Pháp
          </Typography.Text>
        </div>

        <RegisterForm
          loading={register.isPending}
          form={form}
          onSubmit={handleRegister}
        />
      </Card>

      <Modal
        title="Xác thực OTP"
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
      >
        <VerifyOtpForm
          loading={verifyOtp.isPending}
          form={verifyOtpForm}
          onSubmit={handleVerifyOtp}
        />
      </Modal>
    </div>
  );
}
